module.exports = __webpack_public_path__ + "media/images/up_triangle-80cbf39e08ca567e753baf9c66cb4e25.png";